import type { ComponentProps } from 'react';
import { RunInspector } from './RunInspector';

/** Compatibility entry point; all run hosts use the same inspector. */
export function AgentTraceTable(props: ComponentProps<typeof RunInspector>) {
  return <RunInspector {...props} />;
}
